Vue.asyncComponent('cms-password-reset-expired', {
    computed: {
        /**
         * Generate the password recovery link
         *
         * @return {any}
         */
        passwordRecoveryLink() {
            console.log(this.$router.resolve({name: 'password-recovery'}));
            return this.$router.resolve({name: 'password-recovery'}).href;
        }
    },
}, 'cms/pages/cms-password-reset-expired.html');